/* TypeScript file generated from HomeRoute.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as HomeRouteJS from './HomeRoute.re.mjs';

import type {RouterRequest_t as Router_RouterRequest_t} from '../../../src/components/shared/Router.gen';

import type {context as RelayEnv_context} from '../../../src/entry/RelayEnv.gen';

import type {data as WaitForMessages_data} from '../../../src/components/shared/i18n/WaitForMessages.gen';

import type {props as HomePage_props} from '../../../src/components/pages/HomePage.gen';

import type {queryRef as HomePageQuery_graphql_queryRef} from '../../../src/__generated__/HomePageQuery_graphql.gen';

export type params = { readonly lang: (undefined | string) };

export type LoaderArgs_t = {
  readonly context: RelayEnv_context; 
  readonly params: params; 
  readonly request: Router_RouterRequest_t
};

export const Component: React.ComponentType<{}> = HomeRouteJS.component as any;

/** Preloads the whole home page query (no variables) plus the page's message catalog. */
export const loader: (param:LoaderArgs_t) => Promise<(null | WaitForMessages_data<HomePageQuery_graphql_queryRef>)> = HomeRouteJS.loader as any;
